import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';

interface IUpdateLandignPageDesignParams {
  templateId: number;
  title: string;
}

const updateLandingPageDesign = async (
  params: IUpdateLandignPageDesignParams
) => {
  const { templateId, ...payload } = params;
  return await EXPRESS_API.patch(
    `/superadmin/landing-page-designs/${templateId}`,
    { ...payload }
  );
};

export const useUpdateLandingPageDesignMutation = (
  closeModalHandler: () => void
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateLandingPageDesign, {
    onSuccess: () => {
      successToast({ title: 'Template has been successfully updated!' });
      queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGNS',
        exact: false,
      });
      queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
        exact: false,
      });
      closeModalHandler();
    },
    onError: error =>
      showError(
        error || 'An error occured while trying to update the template!'
      ),
  });
};
